
<template>
      <div class="pick">
        <div class="sale-tanpg">
            <div class="sale-tan-box">
                <h6 class="clearfix">
                    <span class="fl">店铺信息</span>
                    <span class="fr">手机尾号</span>
                </h6>
                <div class="pick-box">
                    <ul>
                        <li v-for="(item,index) in pickdata" :key="index">
                            <a href="javascript:void(0);" :data-ownerId="item.ownerId" :class="indexto==index?'check':''" @click="choicefun(index,item.ownerId)">
                                <img :src="item.storeLogo||'//i0.ulecdn.com/i/my/180326/headFiles13.jpg'" alt="">
                                <span class="nam">{{item.storeName}}</span>
                                <span class="num">{{item.userMobileno.substr(-4)}}</span>
                                <i></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <a class="gitnum" @click="give" href="javascript:void(0);">赠送好友</a>
               
            </div>
            <a data-stat="关闭奖励弹层" @click="hidepick(3)" class="rom" href="javascript:void(0);"></a>
        </div>
    </div>
</template>

<script>
export default {
  props:[],
  data () {
      return {
          pickdata:[],
          ownerId:'',
          indexto:-1,
      }
    },
    created(){
      let m=this;
      m.getpickdata();
    }, 
    methods:{
        hidepick(nu){
              this.$parent.shouxiaokapicha(nu);
          },
        getpickdata(){//获取战队成员信息
            let m=this;
            this.HTTP.qryGiverInfohttp().then((res) => {
                if(res.body.returnCode=='0000'){
                    m.pickdata=res.body.data;
                }
            }, (err) => {

            });
        },
        choicefun(index,ownerId){//选择赠送人员
            let m=this;
            m.indexto=index;
            m.ownerId=ownerId
        },
        give(){
            let m=this;
            if(m.indexto==-1){
                JEND.tipBox('请选择赠送人员');
            }else{
                this.$parent.givefun(m.ownerId);
            }
        }
          
    } 
}
</script>

<style scoped>
.pick{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    top: 0;
    left:0;
    z-index: 9999;
}
.pick .sale-tanpg{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 6.42rem;
}
.pick .sale-tan-box{
    height:9.8rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg5.png) no-repeat center;
    background-size: 100% 100%;
    padding: 1.4rem .3rem 0rem;
    padding-top: 1.4rem;
    box-sizing: border-box;
    margin-bottom: .2rem;
}
.pick .sale-tan-box h6{
    font-size: .28rem;
    color: #FFEDC2;
    font-weight: 400;
    text-align: center;
}
.pick .sale-tan-box h6 span{
    display: inline-block;
}
.pick .sale-tan-box h6 .fl{
    float: left;
    width: 60%;
}
.pick .sale-tan-box h6 .fr{
    float: right;
    width: 40%;
}
.pick ul{
    display: block;
    width: 100%;
}
.pick ul li{
    display: block;
    width: 100%;
    position: relative;
    margin-bottom: 0.36rem;
}
.pick ul li a{
    display: block;
    width: 100%;
    height: 0.68rem;
}
.pick ul li img{
    display: inline-block;
    width: 0.68rem;
    height: 0.68rem;
    vertical-align: bottom;
    border-radius: 50%;
}
.pick ul li .nam{
    position: absolute;
    height: 100%;
    left: .92rem;
    top: 0;
    display: inline-block;
    line-height: 0.68rem;
    color: #FFEDC2;
    font-size: .28rem;
    width: 58%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.pick ul li .num{
    display:block;
    line-height: 0.68rem;
    color: #FFEDC2;
    font-size: .28rem;
    float: right;
    margin-right: 0.72rem;
}
.pick ul li i{
    position: absolute;
    right: .1rem;
    top: 0;
    height: 100%;
    width: 0.44rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i2.png) no-repeat center;
    background-size: .44rem .44rem;
}
.pick ul li .check i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i1.png) no-repeat center;
    background-size: .44rem .44rem;
}
.pick-box{
    width: 100%;
    margin-top: 0.2rem;
    height: 5.98rem;
    overflow-y: scroll;
}
.gitnum{
    display: block;
    margin: 0 auto;
    width: 3.48rem;
    height: 0.76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an4.png) no-repeat center;
    background-size: 100% 100%;
    line-height: 0.76rem;
    text-align: center;
    color: #A45E16;
    font-size: .3rem;
    margin-top: 0.46rem;
}
.pick .rom{
    display: block;
    margin: 0 auto;
    background: url(//i1.ulecdn.com/i/event/2018/0511/tencele/tan5.png) no-repeat center;
    background-size: 100% 100%;
    width: .56rem;
    height: .56rem;
}

</style>



// WEBPACK FOOTER //
// src/components/commont/pick.vue